
import React, { useContext } from 'react';
import { Button, Container, Col, Row, Alert } from 'reactstrap';
import { SettingsState } from '../State/Settings';

let audioContext: AudioContext | null = null;
const audioBuffers: {
    bleep?: AudioBuffer,
    buzzer?: AudioBuffer,
} = {};

const rawBuffers: { bleep?: ArrayBuffer, buzzer?: ArrayBuffer } = {};
const prefetchPromise = Promise.all([
    fetch("audio/bleep.mp3").then(r => r.arrayBuffer()).then(b => { rawBuffers.bleep = b }),
    fetch("audio/buzzer.mp3").then(r => r.arrayBuffer()).then(b => { rawBuffers.buzzer = b }),
]).catch(e => console.error("audio prefetch failed:", e));

async function decodeBuffers() {
    await prefetchPromise;
    const [bleep, buzzer] = await Promise.all([
        audioContext!.decodeAudioData(rawBuffers.bleep!),
        audioContext!.decodeAudioData(rawBuffers.buzzer!),
    ]);
    audioBuffers.bleep = bleep;
    audioBuffers.buzzer = buzzer;
}

export function playSound(name: keyof typeof audioBuffers, volume = 0.5) {
    const buffer = audioBuffers[name];
    if (!audioContext || !buffer) {
        initAudio();
        return;
    }
    if (audioContext.state === 'suspended') audioContext.resume();
    const source = audioContext.createBufferSource();
    source.buffer = buffer;
    const gain = audioContext.createGain();
    gain.gain.value = volume;
    source.connect(gain).connect(audioContext.destination);
    source.start();
}

async function initAudio() {
    audioContext = new AudioContext();
    await decodeBuffers();
}

export const SoundCheck: React.FC = () => {
    let settings = useContext(SettingsState)

    return (
        <Container>
            <Row style={{ paddingBottom: '1em' }}>
                <Col xs="12" sm={{ offset: 4, size: 4 }}>
                    <Alert>
                        You'll need to allow the browser to play sounds. <br />
                        {(window.DeviceMotionEvent && typeof (window.DeviceMotionEvent as any).requestPermission === 'function') ? <span>
                            You'll also be asked about device motion permissions. Those will be used to trigger the buzzer. <br />
                        </span> : null}
                        Click the button to proceed!
                    </Alert>
                    <Button block onClick={async () => {
                        if (window.DeviceMotionEvent && typeof (window.DeviceMotionEvent as any).requestPermission === 'function') {
                            console.log("iOS: requesting DeviceMotion permissions");
                            (window.DeviceMotionEvent as any).requestPermission()
                        }

                        await initAudio();
                        playSound("bleep");
                        settings.completeSoundCheck();
                        console.log("passed soundcheck");
                    }}>Ok</Button>
                </Col>
            </Row>
        </Container>
    )
}